import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage // 或者 window.sessionStorage
});

const store = new Vuex.Store({
  modules,
  plugins: [vuexLocal.plugin]
})
export default store